import Head from "expo-router/head";
import { useContext } from "react";

import { LayoutContext, ScrollView } from "@/components";
import { WALMART_EVENTS } from "@/config/adConversionEvents";
import { brandName } from "@/config/brand";
import GeneralCareLandingPage, {
  type PartnerLandingConfig,
} from "@/landing-page/general-care/GeneralCareLandingPage";

const WALMART_CONFIG: PartnerLandingConfig = {
  welcomeChip: {
    prefix: "Welcome",
    partnerName: "Walmart",
    suffix: "customers",
    backgroundColor: "$walmartBlue",
  },
  visitedSplashEventName: WALMART_EVENTS.visitedSplashScreen,
};

export default function WalmartLandingPage() {
  const { headerHeight } = useContext(LayoutContext);
  return (
    <>
      <Head>
        <title>{`Walmart — ${brandName}`}</title>
      </Head>
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          paddingTop: headerHeight.current,
        }}
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
        backgroundColor="$backgroundGround"
      >
        <GeneralCareLandingPage partnerConfig={WALMART_CONFIG} />
      </ScrollView>
    </>
  );
}
